// Redacts credentials from URLs before they reach logs
// (port of lib/security/url_sanitizer.dart).

const REDACTED = '<redacted>';

const SENSITIVE_QUERY_KEYS = new Set([
  'token',
  'access_token',
  'refresh_token',
  'api_key',
  'apikey',
  'x-emby-token',
  'x-mediabrowser-token',
  'auth',
  'authorization',
  'session',
  'sessionid',
  'sid',
]);

const looksSecret = (value: string): boolean => value.length >= 16 || /^[A-Za-z0-9\-_+=/]{12,}$/.test(value);

function isSensitiveQuery(key: string, value: string): boolean {
  const k = key.toLowerCase();
  if (SENSITIVE_QUERY_KEYS.has(k) || k.includes('token') || k.includes('auth') || k.includes('secret')) return true;
  return k === 'key' && looksSecret(value);
}

/** Replaces sensitive query values with `<redacted>`. Unparseable input is returned unchanged. */
export function sanitizeUrl(raw: string): string {
  try {
    const url = new URL(raw, 'http://placeholder.invalid');
    let changed = false;
    for (const [key, value] of [...url.searchParams.entries()]) {
      if (isSensitiveQuery(key, value)) {
        url.searchParams.set(key, REDACTED);
        changed = true;
      }
    }
    if (!changed) return raw;
    const out = url.toString().replace(/%3Credacted%3E/gi, REDACTED);
    return raw.startsWith('http') ? out : out.replace('http://placeholder.invalid', '');
  } catch {
    return raw;
  }
}

/** Redacts every URL embedded in free text (error messages, log lines). */
export function sanitizeText(text: string): string {
  return text.replace(/https?:\/\/[^\s"'<>]+/g, (m) => sanitizeUrl(m));
}
